import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntityMgmtAppService {
  constructor(private http: HttpClient) {}

  loadEntityList(baseUrl: string, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadGridJson?action_code=pthp8s&grid_id=5509`;
    const params = {
      ...(globalService || {}),
      ...(filterParams || {}),
    };
    return this.http.post<any>(url, params, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
    });
  }

  loadEntityDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string): Observable<any> {
    const url = `${customApiUrl}/getEntityDetails?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}`;
    return this.http.post<any>(url, null, { withCredentials: true });
  }

  saveEntityDetails(customApiUrl: string, entityDetails: any): Observable<any> {
    return this.http.post<any>(`${customApiUrl}/editEntityDetailsJson`, entityDetails, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
    });
  }

  saveAddressDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string, addressDetails: any[]): Observable<any> {
    const url = `${customApiUrl}/editAddressDetails?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}`;
    return this.http.post<any>(url, addressDetails, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
    });
  }

  saveOwnershipDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string, ownershipDetails: any[]): Observable<any> {
    const url = `${customApiUrl}/editOwnerShipDetails?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}`;
    return this.http.post<any>(url, ownershipDetails, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
    });
  }

  reloadAddressDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string): Observable<any> {
    const url = `${customApiUrl}/reloadAddress?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}`;
    return this.http.post<any>(url, null, { withCredentials: true });
  }

  reloadOwnershipDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string): Observable<any> {
    const url = `${customApiUrl}/reloadOwnerShipDetails?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}`;
    return this.http.post<any>(url, null, { withCredentials: true });
  }

  deleteAddressDetails(customApiUrl: string, taxYear: string | number, legalEntityId: string, regAddressId: string): Observable<any> {
    const url = `${customApiUrl}/deleteAddressDetails?taxYear=${encodeURIComponent(
      String(taxYear || '')
    )}&legalEntityId=${encodeURIComponent(String(legalEntityId || ''))}&regAddressId=${encodeURIComponent(
      String(regAddressId || '')
    )}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  deleteOwnershipDetails(customApiUrl: string, legalEntityId: string, ownershipId: string): Observable<any> {
    const url = `${customApiUrl}/deleteOwnerShipDetails?legalEntityId=${encodeURIComponent(
      String(legalEntityId || '')
    )}&ownerShipId=${encodeURIComponent(String(ownershipId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getDiagList(baseUrl: string, taxYear: string | number, scenario: string | number, parentMeString: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=zz9no5&tax_year=${encodeURIComponent(
      String(taxYear || '')
    )}&scenario=${encodeURIComponent(String(scenario || ''))}&parent_me_string=${encodeURIComponent(
      String(parentMeString || '')
    )}&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getCategoryList(baseUrl: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=5v72qy&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getSubcategoryList(baseUrl: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=kclpwq&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getMessageList(baseUrl: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=u480j2&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getDisabledLEs(baseUrl: string, taxYear: string | number, scenario: string | number, parentMeString: string, diagKey: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=dlzi5f&tax_year=${encodeURIComponent(
      String(taxYear || '')
    )}&scenario=${encodeURIComponent(String(scenario || ''))}&parent_me_string=${encodeURIComponent(
      String(parentMeString || '')
    )}&diag_key=${encodeURIComponent(String(diagKey || ''))}&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getAllEntities(baseUrl: string, taxYear: string | number, scenario: string | number, parentMeString: string, diagKey: string, ssoId: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=3fxza8&tax_year=${encodeURIComponent(
      String(taxYear || '')
    )}&scenario=${encodeURIComponent(String(scenario || ''))}&parent_me_string=${encodeURIComponent(
      String(parentMeString || '')
    )}&diag_key=${encodeURIComponent(String(diagKey || ''))}&sso_id=${encodeURIComponent(String(ssoId || ''))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  toggleDiagStatus(baseUrl: string, payload: any): Observable<any> {
    return this.postFormUrlEncoded(`${baseUrl}/saveJsonObject`, '7nk5lt', payload);
  }

  editDiagnostic(baseUrl: string, payload: any): Observable<any> {
    return this.postFormUrlEncoded(`${baseUrl}/saveJsonObject`, 'jtjpzv', payload);
  }

  runDiagnostics(baseUrl: string, payload: any): Observable<any> {
    return this.postFormUrlEncoded(`${baseUrl}/saveJsonObject`, '0spzys', payload);
  }

  /**
   * Diagnostics save actions (jtjpzv / 7nk5lt / 0spzys) expect an
   * `application/x-www-form-urlencoded` body containing `action_code` plus the
   * scalar params (tax_year, scenario, parent_me_string, leid CSV, ...). The
   * legacy controller sent them via AngularJS `$http.post` with the form
   * transform; the backend rejects JSON / query-string variants for these
   * action codes, hence centralizing the encoder here.
   */
  private postFormUrlEncoded(url: string, actionCode: string, payload: any): Observable<any> {
    const body = new URLSearchParams();
    body.set('action_code', actionCode);
    if (payload && typeof payload === 'object') {
      Object.keys(payload).forEach((key) => {
        const v = payload[key];
        if (v === null || v === undefined) return;
        body.set(key, String(v));
      });
    }
    return this.http.post<any>(url, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
